import { render, staticRenderFns } from "./part-draft.vue?vue&type=template&id=2e50999d&"
import script from "./part-draft.vue?vue&type=script&lang=js&"
export * from "./part-draft.vue?vue&type=script&lang=js&"
import style0 from "./part-draft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports